module.exports = __webpack_public_path__ + "img/noNoti.cc11ca8a.svg";